
<div class="sm:w-full md:w-7/12 lg:w-4/6 pt-1 flex flex-col justify-center">
	<div class="row custom-wrapper justify-center">
		<div class="col-md-5 justify-center">
			<!-- Form starts -->
			<form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">
				<div class="group-gap">
					<!-- Upload image -->
					<div class="avatar-upload">
						<div class="avatar-edit">
							<input type='file' id="imageUpload" accept=".png, .jpg, .jpeg" #fileInput (change)="uploadFile($event)" />
            			</div>
          			</div>
        		</div>
          		<!-- Submit Button -->
				<j-button 
					className="btn-primary"
					type="submit"
					(click)="fileInput.click()">
					{{ uploadMsg }}
            	</j-button>
          		<!-- <button type="submit" class="btn btn-danger btn-lg btn-block" (click)="fileInput.click()">Carica Immagine</button> -->
      		</form><!-- Form ends -->
    </div>
  </div>
</div>
